import { ɵɵdefineInjectable, Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import Moveable__default, { METHODS, EVENTS, PROPERTIES } from 'moveable';
import * as ɵngcc0 from '@angular/core';
export * from 'moveable';
import { __decorate, __metadata } from 'tslib';
import { withMethods } from 'framework-utils';

class NgxMoveableService {
    constructor() { }
}
NgxMoveableService.ɵfac = function NgxMoveableService_Factory(t) { return new (t || NgxMoveableService)(); };
NgxMoveableService.ɵprov = ɵɵdefineInjectable({ factory: function NgxMoveableService_Factory() { return new NgxMoveableService(); }, token: NgxMoveableService, providedIn: "root" });
NgxMoveableService.ctorParameters = () => [];

class NgxMoveableInterface {
}
__decorate([
    withMethods(METHODS, { dragStart: 'ngDragStart' }),
    __metadata("design:type", Moveable__default)
], NgxMoveableInterface.prototype, "moveable", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMoveableService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

// @dynamic
class NgxMoveableComponent extends NgxMoveableInterface {
    constructor() {
        super();
        EVENTS.forEach(name => {
            // @ts-expect-error
            this[name] = new EventEmitter();
        });
    }
    ngOnInit() {
        const options = {};
        const events = {};
        PROPERTIES.forEach(name => {
            // @ts-expect-error
            options[name] = this[name];
        });
        EVENTS.forEach(name => {
            events[name] = (e) => {
                // @ts-expect-error
                this[name].emit(e);
            };
        });
        this.moveable = new Moveable__default(this.container || document.body, options);
        this.moveable.on(events);
    }
    ngOnChanges(changes) {
        const moveable = this.moveable;
        if (!moveable) {
            return;
        }
        for (const name in changes) {
            const { previousValue, currentValue } = changes[name];
            if (previousValue === currentValue) {
                continue;
            }
            // @ts-expect-error
            moveable[name] = currentValue;
        }
    }
    ngOnDestroy() {
        this.moveable.destroy();
    }
}
NgxMoveableComponent.ɵfac = function NgxMoveableComponent_Factory(t) { return new (t || NgxMoveableComponent)(); };
NgxMoveableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMoveableComponent, selectors: [["ngx-moveable"]], inputs: { draggable: "draggable", resizable: "resizable", scalable: "scalable", rotatable: "rotatable", warpable: "warpable", pinchable: "pinchable", snappable: "snappable", origin: "origin", target: "target", container: "container", throttleDrag: "throttleDrag", throttleDragRotate: "throttleDragRotate", throttleResize: "throttleResize", throttleScale: "throttleScale", throttleRotate: "throttleRotate", keepRatio: "keepRatio", edge: "edge", pinchThreshold: "pinchThreshold", snapCenter: "snapCenter", snapVertical: "snapVertical", snapElement: "snapElement", snapHorizontal: "snapHorizontal", snapThreshold: "snapThreshold", horizontalGuidelines: "horizontalGuidelines", verticalGuidelines: "verticalGuidelines", elementGuidelines: "elementGuidelines", bounds: "bounds", dragArea: "dragArea", rotationPosition: "rotationPosition", baseDirection: "baseDirection", defaultGroupRotate: "defaultGroupRotate", ables: "ables", edgeDraggable: "edgeDraggable", translateZ: "translateZ", passDragArea: "passDragArea", clipTargetBounds: "clipTargetBounds", clipVerticalGuidelines: "clipVerticalGuidelines", clipHorizontalGuidelines: "clipHorizontalGuidelines", clipSnapThreshold: "clipSnapThreshold", className: "className", renderDirections: "renderDirections", scrollable: "scrollable", scrollContainer: "scrollContainer", scrollThreshold: "scrollThreshold", getScrollPosition: "getScrollPosition", rootContainer: "rootContainer", zoom: "zoom", transformOrigin: "transformOrigin", snapDigit: "snapDigit", isDisplaySnapDigit: "isDisplaySnapDigit", innerBounds: "innerBounds", triggerAblesSimultaneously: "triggerAblesSimultaneously", snapGap: "snapGap", pinchOutside: "pinchOutside", padding: "padding", snapDistFormat: "snapDistFormat", dragTarget: "dragTarget", checkInput: "checkInput", cspNonce: "cspNonce", startDragRotate: "startDragRotate", originDraggable: "originDraggable", originRelative: "originRelative", defaultGroupOrigin: "defaultGroupOrigin", groupable: "groupable", clippable: "clippable", customClipPath: "customClipPath", defaultClipPath: "defaultClipPath", clipRelative: "clipRelative", dragWithClip: "dragWithClip", clipArea: "clipArea", roundable: "roundable", roundRelative: "roundRelative", roundClickable: "roundClickable", minRoundControls: "minRoundControls", maxRoundControls: "maxRoundControls", props: "props", individualGroupable: "individualGroupable", portalContainer: "portalContainer", rotationTarget: "rotationTarget", snapContainer: "snapContainer", snapGridWidth: "snapGridWidth", snapGridHeight: "snapGridHeight", isDisplayInnerSnapDigit: "isDisplayInnerSnapDigit" }, outputs: { dragStart: "dragStart", drag: "drag", dragEnd: "dragEnd", dragGroupStart: "dragGroupStart", dragGroup: "dragGroup", dragGroupEnd: "dragGroupEnd", resizeStart: "resizeStart", resize: "resize", resizeEnd: "resizeEnd", resizeGroupStart: "resizeGroupStart", resizeGroup: "resizeGroup", resizeGroupEnd: "resizeGroupEnd", scaleStart: "scaleStart", scale: "scale", scaleEnd: "scaleEnd", scaleGroupStart: "scaleGroupStart", scaleGroup: "scaleGroup", scaleGroupEnd: "scaleGroupEnd", rotateStart: "rotateStart", rotate: "rotate", rotateEnd: "rotateEnd", rotateGroupStart: "rotateGroupStart", rotateGroup: "rotateGroup", rotateGroupEnd: "rotateGroupEnd", warpStart: "warpStart", warp: "warp", warpEnd: "warpEnd", pinchStart: "pinchStart", pinch: "pinch", pinchEnd: "pinchEnd", pinchGroupStart: "pinchGroupStart", pinchGroup: "pinchGroup", pinchGroupEnd: "pinchGroupEnd", click: "click", clickGroup: "clickGroup", renderStart: "renderStart", render: "render", renderEnd: "renderEnd", renderGroupStart: "renderGroupStart", renderGroup: "renderGroup", renderGroupEnd: "renderGroupEnd", scroll: "scroll", scrollGroup: "scrollGroup", snap: "snap", clipStart: "clipStart", clip: "clip", clipEnd: "clipEnd", roundStart: "roundStart", round: "round", roundEnd: "roundEnd", dragOriginStart: "dragOriginStart", dragOrigin: "dragOrigin", dragOriginEnd: "dragOriginEnd", beforeRenderStart: "beforeRenderStart", beforeRender: "beforeRender", beforeRenderEnd: "beforeRenderEnd", beforeRenderGroupStart: "beforeRenderGroupStart", beforeRenderGroup: "beforeRenderGroup", beforeRenderGroupEnd: "beforeRenderGroupEnd" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function NgxMoveableComponent_Template(rf, ctx) { }, encapsulation: 2 });
NgxMoveableComponent.ctorParameters = () => [];
NgxMoveableComponent.propDecorators = {
    draggable: [{ type: Input }],
    resizable: [{ type: Input }],
    scalable: [{ type: Input }],
    rotatable: [{ type: Input }],
    warpable: [{ type: Input }],
    pinchable: [{ type: Input }],
    snappable: [{ type: Input }],
    origin: [{ type: Input }],
    target: [{ type: Input }],
    container: [{ type: Input }],
    throttleDrag: [{ type: Input }],
    throttleDragRotate: [{ type: Input }],
    throttleResize: [{ type: Input }],
    throttleScale: [{ type: Input }],
    throttleRotate: [{ type: Input }],
    keepRatio: [{ type: Input }],
    edge: [{ type: Input }],
    pinchThreshold: [{ type: Input }],
    snapCenter: [{ type: Input }],
    snapVertical: [{ type: Input }],
    snapElement: [{ type: Input }],
    snapHorizontal: [{ type: Input }],
    snapThreshold: [{ type: Input }],
    horizontalGuidelines: [{ type: Input }],
    verticalGuidelines: [{ type: Input }],
    elementGuidelines: [{ type: Input }],
    bounds: [{ type: Input }],
    dragArea: [{ type: Input }],
    rotationPosition: [{ type: Input }],
    baseDirection: [{ type: Input }],
    defaultGroupRotate: [{ type: Input }],
    ables: [{ type: Input }],
    edgeDraggable: [{ type: Input }],
    translateZ: [{ type: Input }],
    passDragArea: [{ type: Input }],
    clipTargetBounds: [{ type: Input }],
    clipVerticalGuidelines: [{ type: Input }],
    clipHorizontalGuidelines: [{ type: Input }],
    clipSnapThreshold: [{ type: Input }],
    className: [{ type: Input }],
    renderDirections: [{ type: Input }],
    scrollable: [{ type: Input }],
    scrollContainer: [{ type: Input }],
    scrollThreshold: [{ type: Input }],
    getScrollPosition: [{ type: Input }],
    rootContainer: [{ type: Input }],
    zoom: [{ type: Input }],
    transformOrigin: [{ type: Input }],
    snapDigit: [{ type: Input }],
    isDisplaySnapDigit: [{ type: Input }],
    innerBounds: [{ type: Input }],
    triggerAblesSimultaneously: [{ type: Input }],
    snapGap: [{ type: Input }],
    pinchOutside: [{ type: Input }],
    padding: [{ type: Input }],
    snapDistFormat: [{ type: Input }],
    dragTarget: [{ type: Input }],
    checkInput: [{ type: Input }],
    cspNonce: [{ type: Input }],
    startDragRotate: [{ type: Input }],
    originDraggable: [{ type: Input }],
    originRelative: [{ type: Input }],
    defaultGroupOrigin: [{ type: Input }],
    groupable: [{ type: Input }],
    clippable: [{ type: Input }],
    customClipPath: [{ type: Input }],
    defaultClipPath: [{ type: Input }],
    clipRelative: [{ type: Input }],
    dragWithClip: [{ type: Input }],
    clipArea: [{ type: Input }],
    roundable: [{ type: Input }],
    roundRelative: [{ type: Input }],
    roundClickable: [{ type: Input }],
    minRoundControls: [{ type: Input }],
    maxRoundControls: [{ type: Input }],
    props: [{ type: Input }],
    individualGroupable: [{ type: Input }],
    portalContainer: [{ type: Input }],
    rotationTarget: [{ type: Input }],
    snapContainer: [{ type: Input }],
    snapGridWidth: [{ type: Input }],
    snapGridHeight: [{ type: Input }],
    isDisplayInnerSnapDigit: [{ type: Input }],
    dragStart: [{ type: Output }],
    drag: [{ type: Output }],
    dragEnd: [{ type: Output }],
    dragGroupStart: [{ type: Output }],
    dragGroup: [{ type: Output }],
    dragGroupEnd: [{ type: Output }],
    resizeStart: [{ type: Output }],
    resize: [{ type: Output }],
    resizeEnd: [{ type: Output }],
    resizeGroupStart: [{ type: Output }],
    resizeGroup: [{ type: Output }],
    resizeGroupEnd: [{ type: Output }],
    scaleStart: [{ type: Output }],
    scale: [{ type: Output }],
    scaleEnd: [{ type: Output }],
    scaleGroupStart: [{ type: Output }],
    scaleGroup: [{ type: Output }],
    scaleGroupEnd: [{ type: Output }],
    rotateStart: [{ type: Output }],
    rotate: [{ type: Output }],
    rotateEnd: [{ type: Output }],
    rotateGroupStart: [{ type: Output }],
    rotateGroup: [{ type: Output }],
    rotateGroupEnd: [{ type: Output }],
    warpStart: [{ type: Output }],
    warp: [{ type: Output }],
    warpEnd: [{ type: Output }],
    pinchStart: [{ type: Output }],
    pinch: [{ type: Output }],
    pinchEnd: [{ type: Output }],
    pinchGroupStart: [{ type: Output }],
    pinchGroup: [{ type: Output }],
    pinchGroupEnd: [{ type: Output }],
    click: [{ type: Output }],
    clickGroup: [{ type: Output }],
    renderStart: [{ type: Output }],
    render: [{ type: Output }],
    renderEnd: [{ type: Output }],
    renderGroupStart: [{ type: Output }],
    renderGroup: [{ type: Output }],
    renderGroupEnd: [{ type: Output }],
    scroll: [{ type: Output }],
    scrollGroup: [{ type: Output }],
    snap: [{ type: Output }],
    clipStart: [{ type: Output }],
    clip: [{ type: Output }],
    clipEnd: [{ type: Output }],
    roundStart: [{ type: Output }],
    round: [{ type: Output }],
    roundEnd: [{ type: Output }],
    dragOriginStart: [{ type: Output }],
    dragOrigin: [{ type: Output }],
    dragOriginEnd: [{ type: Output }],
    beforeRenderStart: [{ type: Output }],
    beforeRender: [{ type: Output }],
    beforeRenderEnd: [{ type: Output }],
    beforeRenderGroupStart: [{ type: Output }],
    beforeRenderGroup: [{ type: Output }],
    beforeRenderGroupEnd: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMoveableComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-moveable',
                template: ''
            }]
    }], function () { return []; }, { draggable: [{
            type: Input
        }], resizable: [{
            type: Input
        }], scalable: [{
            type: Input
        }], rotatable: [{
            type: Input
        }], warpable: [{
            type: Input
        }], pinchable: [{
            type: Input
        }], snappable: [{
            type: Input
        }], origin: [{
            type: Input
        }], target: [{
            type: Input
        }], container: [{
            type: Input
        }], throttleDrag: [{
            type: Input
        }], throttleDragRotate: [{
            type: Input
        }], throttleResize: [{
            type: Input
        }], throttleScale: [{
            type: Input
        }], throttleRotate: [{
            type: Input
        }], keepRatio: [{
            type: Input
        }], edge: [{
            type: Input
        }], pinchThreshold: [{
            type: Input
        }], snapCenter: [{
            type: Input
        }], snapVertical: [{
            type: Input
        }], snapElement: [{
            type: Input
        }], snapHorizontal: [{
            type: Input
        }], snapThreshold: [{
            type: Input
        }], horizontalGuidelines: [{
            type: Input
        }], verticalGuidelines: [{
            type: Input
        }], elementGuidelines: [{
            type: Input
        }], bounds: [{
            type: Input
        }], dragArea: [{
            type: Input
        }], rotationPosition: [{
            type: Input
        }], baseDirection: [{
            type: Input
        }], defaultGroupRotate: [{
            type: Input
        }], ables: [{
            type: Input
        }], edgeDraggable: [{
            type: Input
        }], translateZ: [{
            type: Input
        }], passDragArea: [{
            type: Input
        }], clipTargetBounds: [{
            type: Input
        }], clipVerticalGuidelines: [{
            type: Input
        }], clipHorizontalGuidelines: [{
            type: Input
        }], clipSnapThreshold: [{
            type: Input
        }], className: [{
            type: Input
        }], renderDirections: [{
            type: Input
        }], scrollable: [{
            type: Input
        }], scrollContainer: [{
            type: Input
        }], scrollThreshold: [{
            type: Input
        }], getScrollPosition: [{
            type: Input
        }], rootContainer: [{
            type: Input
        }], zoom: [{
            type: Input
        }], transformOrigin: [{
            type: Input
        }], snapDigit: [{
            type: Input
        }], isDisplaySnapDigit: [{
            type: Input
        }], innerBounds: [{
            type: Input
        }], triggerAblesSimultaneously: [{
            type: Input
        }], snapGap: [{
            type: Input
        }], pinchOutside: [{
            type: Input
        }], padding: [{
            type: Input
        }], snapDistFormat: [{
            type: Input
        }], dragTarget: [{
            type: Input
        }], checkInput: [{
            type: Input
        }], cspNonce: [{
            type: Input
        }], startDragRotate: [{
            type: Input
        }], originDraggable: [{
            type: Input
        }], originRelative: [{
            type: Input
        }], defaultGroupOrigin: [{
            type: Input
        }], groupable: [{
            type: Input
        }], clippable: [{
            type: Input
        }], customClipPath: [{
            type: Input
        }], defaultClipPath: [{
            type: Input
        }], clipRelative: [{
            type: Input
        }], dragWithClip: [{
            type: Input
        }], clipArea: [{
            type: Input
        }], roundable: [{
            type: Input
        }], roundRelative: [{
            type: Input
        }], roundClickable: [{
            type: Input
        }], minRoundControls: [{
            type: Input
        }], maxRoundControls: [{
            type: Input
        }], props: [{
            type: Input
        }], individualGroupable: [{
            type: Input
        }], portalContainer: [{
            type: Input
        }], rotationTarget: [{
            type: Input
        }], snapContainer: [{
            type: Input
        }], snapGridWidth: [{
            type: Input
        }], snapGridHeight: [{
            type: Input
        }], isDisplayInnerSnapDigit: [{
            type: Input
        }], dragStart: [{
            type: Output
        }], drag: [{
            type: Output
        }], dragEnd: [{
            type: Output
        }], dragGroupStart: [{
            type: Output
        }], dragGroup: [{
            type: Output
        }], dragGroupEnd: [{
            type: Output
        }], resizeStart: [{
            type: Output
        }], resize: [{
            type: Output
        }], resizeEnd: [{
            type: Output
        }], resizeGroupStart: [{
            type: Output
        }], resizeGroup: [{
            type: Output
        }], resizeGroupEnd: [{
            type: Output
        }], scaleStart: [{
            type: Output
        }], scale: [{
            type: Output
        }], scaleEnd: [{
            type: Output
        }], scaleGroupStart: [{
            type: Output
        }], scaleGroup: [{
            type: Output
        }], scaleGroupEnd: [{
            type: Output
        }], rotateStart: [{
            type: Output
        }], rotate: [{
            type: Output
        }], rotateEnd: [{
            type: Output
        }], rotateGroupStart: [{
            type: Output
        }], rotateGroup: [{
            type: Output
        }], rotateGroupEnd: [{
            type: Output
        }], warpStart: [{
            type: Output
        }], warp: [{
            type: Output
        }], warpEnd: [{
            type: Output
        }], pinchStart: [{
            type: Output
        }], pinch: [{
            type: Output
        }], pinchEnd: [{
            type: Output
        }], pinchGroupStart: [{
            type: Output
        }], pinchGroup: [{
            type: Output
        }], pinchGroupEnd: [{
            type: Output
        }], click: [{
            type: Output
        }], clickGroup: [{
            type: Output
        }], renderStart: [{
            type: Output
        }], render: [{
            type: Output
        }], renderEnd: [{
            type: Output
        }], renderGroupStart: [{
            type: Output
        }], renderGroup: [{
            type: Output
        }], renderGroupEnd: [{
            type: Output
        }], scroll: [{
            type: Output
        }], scrollGroup: [{
            type: Output
        }], snap: [{
            type: Output
        }], clipStart: [{
            type: Output
        }], clip: [{
            type: Output
        }], clipEnd: [{
            type: Output
        }], roundStart: [{
            type: Output
        }], round: [{
            type: Output
        }], roundEnd: [{
            type: Output
        }], dragOriginStart: [{
            type: Output
        }], dragOrigin: [{
            type: Output
        }], dragOriginEnd: [{
            type: Output
        }], beforeRenderStart: [{
            type: Output
        }], beforeRender: [{
            type: Output
        }], beforeRenderEnd: [{
            type: Output
        }], beforeRenderGroupStart: [{
            type: Output
        }], beforeRenderGroup: [{
            type: Output
        }], beforeRenderGroupEnd: [{
            type: Output
        }] }); })();

class NgxMoveableModule {
}
NgxMoveableModule.ɵfac = function NgxMoveableModule_Factory(t) { return new (t || NgxMoveableModule)(); };
NgxMoveableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxMoveableModule });
NgxMoveableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMoveableModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxMoveableComponent],
                imports: [],
                exports: [NgxMoveableComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxMoveableModule, { declarations: [NgxMoveableComponent], exports: [NgxMoveableComponent] }); })();

/*
 * Public API Surface of ngx-moveable
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxMoveableComponent, NgxMoveableModule, NgxMoveableService, NgxMoveableInterface as ɵa };

